module.exports = __webpack_public_path__ + "img/aboutus.39107600.png";